import Lenis from '@studio-freight/lenis'

/**
 * Initializes and configures Lenis smooth scrolling
 */
function initSmoothScroll() {
  // Initialize Lenis with options
  const lenis = new Lenis({
    duration: 1.2,          // Animation duration (in seconds)
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Easing function
    direction: 'vertical',  // Scroll direction
    gestureDirection: 'vertical', // Gesture direction
    smooth: true,           // Enable smooth scrolling
    mouseMultiplier: 1,     // Mouse wheel multiplier
    smoothTouch: false,     // Smooth scrolling for touch devices
    touchMultiplier: 2,     // Touch multiplier
    infinite: false,        // Enable infinite scrolling
  })

  // Uncomment to debug scroll values
  // lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
  //   console.log({ scroll, limit, velocity, direction, progress })
  // })

  // Bind RAF (requestAnimationFrame)
  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
  }

  requestAnimationFrame(raf)

  return lenis;
}

export default initSmoothScroll;